import { GarnerApiAllocationsClientV1 } from '@garner-health/api-client/svc-account/api-allocations/api-allocations-v1';

import createLogger from '~/logging';

import { baseClientOptions, getDefaultHeaders } from './common';

const log = createLogger(__filename);

export type ApiAllocation = {
  id: number;
  clientId: number;
  scope: string;
  networkIds: string[];
  createdAt: string;
  updatedAt: string;
};

export class ApiAllocationClient {
  readonly client: GarnerApiAllocationsClientV1;

  constructor() {
    this.client = new GarnerApiAllocationsClientV1(baseClientOptions);
  }

  async getDataProApiAllocation(clientId: number): Promise<ApiAllocation | null> {
    const response = await this.client
      .get('/api-allocations', {
        headers: await getDefaultHeaders(),
        query: { clientId },
      })
      .onStatus(200, r => {
        const items = r.json.items;
        const dataProAllocations = items.filter((allocation: ApiAllocation) =>
          allocation.scope.startsWith('getgarner/datapro:'),
        );

        if (dataProAllocations.length === 0) {
          return null;
        }

        if (dataProAllocations.length > 1) {
          log.warn(
            { clientId, dataProAllocationId: dataProAllocations.map((a: ApiAllocation) => a.id) },
            'Multiple datapro API allocations found for client. merging network IDs',
          );
        }

        let finalAllocation: ApiAllocation;
        if (dataProAllocations.length === 1) {
          finalAllocation = dataProAllocations[0];
        } else {
          const allNetworkIds = new Set<string>();
          dataProAllocations.forEach((allocation: ApiAllocation) => {
            allocation.networkIds.forEach((id: string) => allNetworkIds.add(id));
          });

          finalAllocation = {
            ...dataProAllocations[0],
            networkIds: Array.from(allNetworkIds),
          };
        }

        return finalAllocation;
      })
      .catch(err => {
        log.error({ err, clientId }, 'Failed to fetch API allocation');
        throw err;
      });

    return response;
  }
}

export const apiAllocationClient = new ApiAllocationClient();
